module.exports = __webpack_public_path__ + "static/media/chevron_right_blue.84e03034.svg";


//////////////////
// WEBPACK FOOTER
// ./src/spread/chartOfAccounts/chevron_right_blue.svg
// module id = 2203
// module chunks = 0